import { Reveal } from "@/components/Reveal";
import { HeroBackground } from "@/components/HeroBackground";
import { container } from "@/lib/ui";

/**
 * Shared inner-page header. Reuses the Hero's living energy-network backdrop so
 * every page opens with the same premium, on-brand atmosphere.
 */
export function PageBanner({
  title,
  subtitle,
  eyebrow,
  center = false,
}: {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  center?: boolean;
}) {
  return (
    <section className="relative overflow-hidden bg-[#070b10] pb-20 pt-36 text-white md:pb-28 md:pt-44">
      <HeroBackground className="absolute inset-0 h-full w-full [mix-blend-mode:screen]" />

      <div className="pointer-events-none absolute -left-32 -top-24 h-[32rem] w-[32rem] rounded-full bg-[radial-gradient(circle,rgba(1,120,254,0.2),transparent_60%)] blur-3xl" />
      <div className="pointer-events-none absolute -right-24 top-1/3 h-[28rem] w-[28rem] rounded-full bg-[radial-gradient(circle,rgba(0,200,247,0.14),transparent_60%)] blur-3xl" />

      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#070b10] via-[#070b10]/25 to-[#070b10]/55" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-brand/60 to-transparent" />

      <div className={`${container} relative ${center ? "text-center" : ""}`}>
        <Reveal>
          {eyebrow && (
            <span className="mb-5 inline-flex items-center gap-2.5 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-medium tracking-wide text-white/80 backdrop-blur sm:text-sm">
              <span className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-cyan opacity-75" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-brand-cyan" />
              </span>
              {eyebrow}
            </span>
          )}
          <h1 className="font-display text-4xl font-bold tracking-tight md:text-6xl">{title}</h1>
          {subtitle && (
            <p className={`mt-5 max-w-2xl text-lg text-[#9aa4ad] ${center ? "mx-auto" : ""}`}>
              {subtitle}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
